import React, { memo, useEffect, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, useTheme } from "@mui/material";
import { NoAccountsStub, WithLoadingSpinner } from "@components";
import { DividendChartData } from "@api/v1/hooks/performance/useDividendsChartData";
import { ChartWrapper } from "../../common";
import { useHighchartsOptions } from "./useChartOptions";

export { type DividendChartData };

type Props = {
  chartData: DividendChartData[];
  isFetching: boolean;
  isFetched: boolean;
  interval: IntervalType;
  height?: number;
};

export const DividendsChart = memo((props: Props) => {
  const { chartData, isFetching, isFetched, height } = props;
  const theme = useTheme();
  const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
  const chartOptions = useHighchartsOptions(chartData, theme, height);
  const anyDividends = chartData.some((obj) => obj.y > 0);

  useEffect(() => {
    chartComponentRef.current?.chart?.reflow();
  }, [chartOptions]);

  return (
    <Box
      sx={{
        "& .highcharts-tooltip-container": {
          pointerEvents: "auto !important",
        },
      }}
    >
      <WithLoadingSpinner isLoading={!isFetched || isFetching}>
        {isFetched && !isFetching && !anyDividends ? (
          <NoAccountsStub height="330px" />
        ) : (
          <ChartWrapper>
            <HighchartsReact
              ref={chartComponentRef}
              highcharts={Highcharts}
              options={chartOptions}
            />
          </ChartWrapper>
        )}
      </WithLoadingSpinner>
    </Box>
  );
});
